import { render, staticRenderFns } from "./Iqc.vue?vue&type=template&id=5ba54f8d"
import script from "./Iqc.vue?vue&type=script&lang=js"
export * from "./Iqc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports